import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import PageHero from '../components/PageHero';
import useReveal from '../hooks/useReveal';

// Genbrugeligt segment-layout til Asset Managers & Hovedentreprenører
const SegmentPage = ({ data }) => {
  const ref = useReveal();
  return (
    <div ref={ref}>
      <PageHero eyebrow={data.eyebrow} title={data.title} image={data.image} />

      {/* FOKUS / INTRO */}
      <section className="bg-bone">
        <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4 reveal">
            <p className="text-[11px] uppercase tracking-[0.3em] text-stone">{data.focusLabel}</p>
          </div>
          <div className="md:col-span-8 reveal">
            <p className="font-serif font-light text-2xl md:text-4xl leading-[1.4]">{data.intro}</p>
          </div>
        </div>
      </section>

      {/* PRIORITETER */}
      <section className="bg-paper border-y border-ink/10">
        <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 md:py-32">
          <div className="reveal mb-14 max-w-2xl">
            <h2 className="font-serif font-light text-4xl md:text-5xl">{data.prioritiesHeading}</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-12">
            {data.priorities.map((item, i) => (
              <div key={item.title} className="reveal flex gap-6 border-t border-ink/10 pt-8">
                <span className="font-serif text-clay text-xl shrink-0">0{i + 1}</span>
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl font-light">{item.title}</h3>
                  <p className="mt-3 text-sm font-light leading-relaxed text-stone">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-bone">
        <div className="mx-auto max-w-[1100px] px-6 md:px-12 py-24 md:py-32 text-center reveal">
          <h2 className="font-serif font-light text-3xl md:text-5xl leading-tight">{data.ctaHeading}</h2>
          <Link
            to={data.ctaPath}
            className="mt-10 inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.25em] border-b border-ink/50 pb-1 hover:border-ink transition-colors"
          >
            {data.ctaLabel} <ArrowRight size={14} strokeWidth={1.4} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default SegmentPage;
